import axios, { AxiosHeaders } from 'axios'

import {
  getAccessToken,
  getAccessTokenKey,
  getRefreshToken,
  getRefreshTokenKey,
} from 'cng-common/helpers/access'
import Logger from 'core/utils/Logger'
import APPLICATION_SETTINGS from 'src/config/settings'

import { isTokenExpired, readTokenPayload, refreshToken as refreshTokenRequest } from '../auth'

const accessToken = getAccessToken()
const headers = new AxiosHeaders()

headers.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
headers.set('Authorization', `Bearer ${accessToken}`)

export const axiosInstance = axios.create({ baseURL: APPLICATION_SETTINGS.dataServerUrl, headers })

axiosInstance.interceptors.request.use(async (config) => {
  const accessToken = getAccessToken()
  if (!accessToken) {
    Logger.error({ accessToken, message: 'There is no token value, reload page, please.' })
    return config
  }

  const payload = readTokenPayload(accessToken)
  if (payload && !isTokenExpired(payload)) {
    config.headers.set('Authorization', `Bearer ${accessToken}`)
    return config
  }

  const refreshToken = getRefreshToken()
  if (!refreshToken) {
    Logger.error({ refreshToken, message: 'There is no token value, reload page, please.' })
    return config
  }

  const response = await refreshTokenRequest({ accessToken, refreshToken })
  if (!response) {
    Logger.error({ response, message: 'Unable to refresh token' })
    return config
  }

  const { accessToken: newAccessToken, refreshToken: newRefreshToken } = response
  localStorage.setItem(getAccessTokenKey(), newAccessToken)
  localStorage.setItem(getRefreshTokenKey(), newRefreshToken)

  config.headers.set('Authorization', `Bearer ${newAccessToken}`)
  return config
})
